import config from "../../config/config"

let timeout: ReturnType<typeof setTimeout>
export const debounce = (callback: () => void, delay: number = config.ui.componentsConfig.searchInputDelay) => {
	clearTimeout(timeout)
	timeout = setTimeout(() => {
		callback()
	}, delay)
}
